import {
    FETCH_QUESTIONNAIRES,
    FETCH_ADMIN_QUESTIONNAIRES,
    FETCH_SURVEYANSWERS,
    FETCH_VOTES,
    FETCH_ADMIN_VOTES
} from '../actions/questionnaires';


export const initialState = {
    isFetching: true,
    data: null
};

export const questionnaires = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_QUESTIONNAIRES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_QUESTIONNAIRES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const adminQuestionnaires = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ADMIN_QUESTIONNAIRES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ADMIN_QUESTIONNAIRES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const surveyAnswers = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_SURVEYANSWERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_SURVEYANSWERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const votes = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_VOTES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_VOTES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const adminVotes = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ADMIN_VOTES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ADMIN_VOTES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}







// WEBPACK FOOTER //
// ./src/redux/reducers/questionnaires.js